import { ConversionUnit } from '@atom/types/schema';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';

const MAX_QUANTITY_DECIMALS = 2;

export const formatQuantity = (input?: string | number): string =>
  Number(input || 0).toLocaleString('en-US', {
    maximumFractionDigits: MAX_QUANTITY_DECIMALS,
  });

/**
 * e.g. "83 PINT". The unit is omitted when the asset has none.
 */
export const formatQuantityWithUnit = (
  input?: string | number,
  unit?: string,
): string => [formatQuantity(input), unit].filter(Boolean).join(' ');

/**
 * e.g. "$1.00 / PINT". The unit is omitted when the asset has none.
 */
export const formatRateWithUnit = (
  rate?: string | number,
  unit?: string,
): string => [numberToLocaleString(rate), unit].filter(Boolean).join(' / ');

/**
 * conversionNumber is how many base units make up one conversion unit
 * (1 GALLON = 8 PINT), so quantities divide and per-unit costs multiply.
 */
export const toConvertedQuantity = (
  input: string | number | undefined,
  conversionUnit: ConversionUnit,
): number => Number(input || 0) / conversionUnit.conversionNumber;

export const toConvertedRate = (
  rate: string | number | undefined,
  conversionUnit: ConversionUnit,
): number => Number(rate || 0) * conversionUnit.conversionNumber;

/**
 * inactive units can't be selected, but the default unit is always active
 */
export const getActiveConversionUnits = (
  conversionUnits: ConversionUnit[] | null,
): ConversionUnit[] =>
  (conversionUnits ?? []).filter(conversionUnit => conversionUnit.active);

export const getDefaultConversionUnit = (
  conversionUnits: ConversionUnit[] | null,
): ConversionUnit | undefined =>
  (conversionUnits ?? []).find(conversionUnit => conversionUnit.isDefault);
